const KEY_NUMBER_REGEX = /^[a-zA-Z0-9._\b]+$/
const KEY_INTEGER_REGEX = /^[0-9]+$/

export {
  KEY_NUMBER_REGEX,
  KEY_INTEGER_REGEX
}